import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';

import { TicketDetails } from './TicketDetails';
import { useCreatDirectChannelRequest, useTicketDetails } from '../../services/tickets/useTickets';
import { useTicketStore } from '../../store/ticket';
import { useUserStore } from '../../store/user';
import { NotFound } from '../../components/NotFound';
import { LoadingOverlay } from '../../components/Loading';
import { Ticket } from '../../types/tickets/types';
import { ModalConfirm } from './ModalConfirm/ModalConfirm';
import { useShowNotification } from '../../hooks/useShowNotificationContext';


export const TicketDetailsContainer = () => {

  const navigate = useNavigate();
  const { ticket, clearTicket } = useTicketStore();
  const { user } = useUserStore();
  const { id } = useParams<{ id: string }>();
  const ticketId = id ? parseInt(id, 10) : undefined;

  const [openModal, setOpenModal] = useState(false);

  const { data, isFetching, isError, error, refetch } = useTicketDetails(
    ticketId || 0,
    { enabled: !!ticketId }
  );

  const { showSucessNotification, showErrorNotification } = useShowNotification()
  const { mutate, isPending } = useCreatDirectChannelRequest()

  const onGoBack = () => {
    clearTicket()
    navigate('/tickets')
  }

  const onSendFeedback = (ticket: Ticket) => {
    navigate(`/tickets/feedback/${ticket.referenciaExterna}`);
  }

  const onCreatDirectChannel = () => {
    setOpenModal(true);
  }

  const onRemovePermissionDirectChannel = () => {
    if (user) {
      useUserStore.getState().setUser({
        ...user,
        clientePodeSolicitarCanalDireto: false,
      });
    }
  }


  const onConfirm = () => {
    if (!ticketId) return;

    mutate(ticketId, {
      onSuccess: () => {
        showSucessNotification("Feedback por canal direto solicitado com sucesso!");
        onRemovePermissionDirectChannel();
      },
      onError: (e) => {
        showErrorNotification(e, 'Falha no login: criar feedback de canal direto tente novamente.');
      },
    },
    )

    setOpenModal(false);
  }



  return (
    <>
      {isError && (
        <NotFound
          error={error}
          defaultMessage={'Erro ao carregar a o histórico da ficha.'}
          retry={refetch}
        />
      )}

      {isFetching || isPending && <LoadingOverlay />}


      {ticket && data && user &&
        <TicketDetails ticket={ticket}
          user={user}
          historicoTickets={data.historicos}
          onGoBack={onGoBack}
          onSendFeedback={onSendFeedback}
          onCreatDirectChannel={onCreatDirectChannel}
        />
      }

      {openModal &&
        <ModalConfirm
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onConfirm={onConfirm}
        />
      }

    </>
  );
}; 